import froentenda from "../images/froentend a.png";
import froendendb from "../images/froentend b.png";
import froentendc from "../images/froentend c.png";
import froentendd from "../images/froentend d.png";
import netflix from "../images/netflix.png";
import ecommerce from "../images/Ecommerce.png";
import youtube from "../images/youtube.png";
import yagarika from "../images/yagarika.png";
import webrtc from "../images/web rtc.png";

const portfolios = [
  {
    id: "01",
    imgUrl: froentenda,
    category: "FROENTEND",
    title: "web-developer-joining community",
    description:
      "In this project i am use html, css & Javasript. This is bacically froendend part as well as a UI inerface",
    technologies: ["HTML", "CSS", "JAVASCRIPT"],
    siteUrl: "#",
  },
  {
    id: "02",
    imgUrl: froendendb,
    category: "FROENTEND",
    title: "REALTIME CHAT APLICATION USER INTERFACE",
    description:
      "This project in realtime chat application base project. in this proect I am creating realtime hat application UI",
    technologies: ["REACT", "CSS", "METARIAL UI"],
    siteUrl: "#",
  },
  {
    id: "03",
    imgUrl: froentendc,
    category: "FROENTEND",
    title: "CROUWD FUNDING APPLICATION ",
    description:
      "It is a blokchain base project. In this application I am creating froentend part of crouwdfinding app",
    technologies: ["React", "Tailwind css", "CSS"],
    siteUrl: "#",
  },
  {
    id: "04",
    imgUrl: froentendd,
    category: "FROENTEND",
    title: "FOOD DELEVERY APP",
    description:
      "In this project I am creating a food delevery app. This is a froentend project also",
    technologies: ["HTML", "CSS", "JAVASCRIPT"],
    siteUrl: "#",
  },
  {
    id: "05",
    imgUrl: netflix,
    category: "MERN-STACK",
    title: "NETFLIX CLONE",
    description:
      "In this project I have learn how to fecth the data using APIs from backend. I have learn how to integrate APIs in this Project. This is a MERN stack project.",
    technologies: ["REACT", "NODE.JS", "EXPRESS", "MONGODB"],
    siteUrl: "#",
  },

  {
    id: "06",
    imgUrl: ecommerce,
    category: "MERN-STACK",
    title: "ECOMMERCE APPLICATION",
    description:
      "In this project i am creating Ecommerce full-stack application. In this project I have learn how to connect froentend and backend. I have learn how to integrate online payment method in a website. I have also learn how to APIs call from backend",
    technologies: ["REACT", "NODE.JS", "EXPRESS", "MONGODB", "Razorpay"],
    siteUrl: "#",
  },
  {
    id: "07",
    imgUrl: youtube,
    category: "MERN-STACK",
    title: "YOUTUBE CLONE",
    description:
      "In this project how to youtube works are actually. I have learn how to fetch data from APIs. Integrate many APIs from google",
    technologies: ["REACT", "NODE.JS", "EXPRESS", "MONGODB"],
    siteUrl: "#",
  },
  {
    id: "08",
    imgUrl: yagarika,
    category: "MERN-STACK",
    title: "Propertity sell-buy website",
    description:
      "I have creating amazing UI interface in this app. In this project i have use refine package also. in this project I have learn how to add pictures and so many properties. I have learn email authentication .",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB"],
    siteUrl: "#",
  },
  {
    id: "09",
    imgUrl: webrtc,
    category: "MERN-STACK",
    title: "VIDEO CHATTING USING WEB-RTC",
    description:
      "In this project I have created video chatting app using web-rtc. This is very powerful concept and much more intrest. It is a peer to Peer connection.No third party entry in this video call.",
    technologies: ["REACT", "NODE.JS", "WEB-RTC"],
    siteUrl: "#",
  },
];

export default portfolios;
